import React, {Component} from 'react';
import {Grid,Cell,List,ListItem,ListItemContent} from 'react-mdl';
import { inherits } from 'util';

class Contact extends Component{
    render(){
        return(
        <div className="contact-body">
          <Grid className="contact-grid">
            <Cell col={6}>
            <h2> Mrityunjoy Nath </h2>
            <img
              src="http://newliferanchblogs.com/wp-content/uploads/2017/03/NLR-Testimonial-Avatar-Male-2.png"
              alt = "avatar"
              style = {{height:'250px'}}
            />
            <p style={{width:'70%', margin:'auto', paddingTop:'1em'}}>
            Having no limit is my goal. Connecting with everyone to know every detail and use most advanced mechinery.
            </p>
            </Cell>
            <Cell col={6}>
              <h2>Contact Me</h2>
              <hr/>

              <List>
                <ListItem>
                  <ListItemContent style={{fontSize:"30px",fontFamily:"Anton"}}>
                  <i className="fa fa-phone"/>
                  9678452532
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize:"30px",fontFamily:"Anton"}}>
                  <i className="fa fa-location-arrow"/>
                  NIT Silchar Campus
                  </ListItemContent>
                </ListItem>
              </List>

              <ListItem>
                <ListItemContent style={{fontSize:"25px",fontFamily:"Anton"}}>
                <i className="fa fa-envelope"/>
                <a href="mailto:mrityunjoynath10@gmail.com" style={{textDecoration:"none",color:"inherit"}}>mrityunjoynath10@gmail.com</a>
                </ListItemContent>
              </ListItem>

              <ListItem>
                <ListItemContent style={{fontSize:"30px",fontFamily:"Anton"}}>
                <i className="fa fa-briefcase"/>
                NIT Silchar
                </ListItemContent>
              </ListItem>

            </Cell>
          </Grid>
        </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/contact.js